import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import type {
  InsistenceFilters,
  InsistenceListRequest,
  InsistenceMeanDelayByInsuranceCompanyRequest,
} from 'types'

import {
  insistenceCount,
  insistenceGet,
  insistenceList,
  insistenceMeanDelayByInsuranceCompany,
} from './insistence.service'

export const insistenceKeyFactory = {
  base: () => ['insistences'],
  list: (request?: InsistenceListRequest) => [
    ...insistenceKeyFactory.base(),
    'list',
    ...(request ? [request] : []),
  ],
  count: (filters?: InsistenceFilters) => [
    ...insistenceKeyFactory.base(),
    'count',
    ...(filters ? [filters] : []),
  ],
  get: (insistenceUuid: string) => [
    ...insistenceKeyFactory.base(),
    insistenceUuid,
  ],
  meanDelayByInsuranceCompany: (
    request?: InsistenceMeanDelayByInsuranceCompanyRequest,
  ) => [
    ...insistenceKeyFactory.base(),
    'mean-delay-by-insurance-company',
    ...(request ? [request] : []),
  ],
}

export const queryInsistenceList = (request: InsistenceListRequest) =>
  queryOptions({
    queryKey: insistenceKeyFactory.list(request),
    queryFn: () => insistenceList(request),
    placeholderData: keepPreviousData,
  })

export const queryInsistenceCount = (filters?: InsistenceFilters) =>
  queryOptions({
    queryKey: insistenceKeyFactory.count(filters),
    queryFn: () => insistenceCount(filters),
    placeholderData: keepPreviousData,
  })

export const queryInsistenceGet = (insistenceUuid: string) =>
  queryOptions({
    queryKey: insistenceKeyFactory.get(insistenceUuid),
    queryFn: () => insistenceGet(insistenceUuid),
  })

export const queryInsistenceMeanDelayByInsuranceCompany = (
  request?: InsistenceMeanDelayByInsuranceCompanyRequest,
) =>
  queryOptions({
    queryKey: insistenceKeyFactory.meanDelayByInsuranceCompany(request),
    queryFn: () => insistenceMeanDelayByInsuranceCompany(request),
  })
